export class TemplatesConfig {
  configs: TemplateConfig[];

  constructor(json: any) {
    this.configs = [];
    if (json.groups) {
      this.configs.push(new TemplateConfig(json));
    }
  }

  getTemplateConfig(): TemplateConfig {
    if (this.configs.length > 0) {
      return this.configs[0];
    }
    return null;
  }
}

export class TemplateConfig {
  label: string;
  groups: Group[];
  notes: string[];

  constructor(json: any) {
    this.label = json.label ? json.label : '';
    this.groups = [];
    if (json.groups) {
      for (const entry of json.groups) {
        this.groups.push(new Group(entry));
      }
    }
    this.notes = [];
    if (json.notes) {
      for (const note of json.notes) {
        this.notes.push(note);
      }
    }
  }
}

export class Group {
  label: string;
  value: string;
  templates: Template[];

  constructor(json: any) {
    this.label = json.label ? json.label : '';
    this.value = json.value ? json.value : '';
    this.templates = [];
    if (json.templates) {
      for (const entry of json.templates) {
        this.templates.push(new Template(entry));
      }
    }
  }

  public isSupported(template: string): boolean {
    for (const p of this.templates) {
      if (p.value === template) {
        return true;
      }
    }
    return false;
  }
}

export class Template {
  label: string;
  value: string;

  constructor(json: any) {
    this.label = json.label ? json.label : '';
    this.value = json.value ? json.value : '';
  }
}
